import { Empty, Space, Table, Typography } from 'antd';
import { IxTableResult } from '../../@types/ghePage5/types';

type Props = {
  result: IxTableResult | null;
};

export const GheIxTablePreview = ({ result }: Props) => {
  if (!result) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Generate an IX table to preview results."
        data-testid="ghe-page5-empty-preview"
      />
    );
  }

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Typography.Text data-testid="ghe-page5-preview-metadata">
        Type: {result.table_type} | Generated: {new Date(result.generated_at).toLocaleString()}
      </Typography.Text>
      <Typography.Text data-testid="ghe-page5-row-count">
        Rows: {result.row_count}
      </Typography.Text>
      <Table
        rowKey={(_, idx) => String(idx)}
        dataSource={result.rows}
        pagination={{ pageSize: 10 }}
        columns={result.columns.map(column => ({
          title: column.unit ? `${column.label} (${column.unit})` : column.label,
          dataIndex: column.key,
          key: column.key
        }))}
        data-testid="ghe-page5-table-preview"
      />
    </Space>
  );
};
